// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sulu-untranslated{animation:none!important;border-radius:15px;margin-bottom:2vh;margin-top:2vh;padding:13px}.sulu-untranslated,.sulu-untranslated:hover{box-shadow:0 2px 4px rgba(0,0,0,.1)}.sulu-untranslated .razlet-notification__text{font-size:15px}@media screen and (min-width:480px){.sulu-untranslated .razlet-notification__text{font-size:24px}}.sulu-untranslated .razlet-notification__close{visibility:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
